import { CalendarOutlined } from '@ant-design/icons';
import { SeasonGroupNames } from '@omniafishing/core';
import { Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import SvgFallIcon from '../../components/svg/fall_icon';
import SvgIceIcon from '../../components/svg/ice_icon';
import SvgSpringIcon from '../../components/svg/spring_icon';
import SvgSummerIcon from '../../components/svg/summer_icon';
import SvgWinterIcon from '../../components/svg/winter_icon';
import { getSeasonGroups } from '../../redux/reference_data';
import styles from './season_group_select.less';

interface SeasonGroupSelectProps {
  value: string;
  onChange: (val: string) => void;
}

export const SeasonGroupSelect = (props: SeasonGroupSelectProps) => {
  const { value, onChange } = props;

  const allSeasonGroups = useSelector(getSeasonGroups);
  const selectOptions = [
    {
      display_name: 'All Seasons',
      name: null as SeasonGroupNames,
    },
    ...allSeasonGroups,
  ];

  const seasonIcons = {
    null: <CalendarOutlined />,
    [SeasonGroupNames.FALL]: <SvgFallIcon />,
    [SeasonGroupNames.ICE]: <SvgIceIcon />,
    [SeasonGroupNames.SPRING]: <SvgSpringIcon />,
    [SeasonGroupNames.SUMMER]: <SvgSummerIcon />,
    [SeasonGroupNames.WINTER]: <SvgWinterIcon />,
  };

  return (
    <Select
      bordered={false}
      className={styles.select}
      dropdownMatchSelectWidth={false}
      options={selectOptions.map((s) => ({
        label: (
          <span className={styles.label}>
            {seasonIcons[s.name]}
            {s.display_name}
          </span>
        ),
        value: s.name,
      }))}
      value={value}
      onChange={(val) => {
        onChange(val);
      }}
    />
  );
};
